import { log } from '@domgen/shared/utils/log';
import { STORAGE_KEY } from '../../const/app';
import { PersistedState } from '../../models/store/persistedState';
import { StoreContext } from '../../models/store/context';

export const saveSession = (context: StoreContext) => {
  const payload: PersistedState = {
    context: {
      ...context,
    },
    dateUpdated: Date.now(),
  };

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (error) {
    log.error({ message: 'Failed to save session', data: error });
  }
};
